import {
  capitalize,
  formatDate,
  formatTime,
  numberToWordsOrdinal,
  daysRemaining,
  formatReviewDate
} from '@/utils';

export const registerFilters = (app) => {
  app.config.globalProperties.$capitalize = capitalize;
  app.config.globalProperties.$formatDate = formatDate;
  app.config.globalProperties.$formatTime = formatTime;
  app.config.globalProperties.$numberToWordsOrdinal = numberToWordsOrdinal;
  app.config.globalProperties.$daysRemaining = daysRemaining;
  app.config.globalProperties.$formatReviewDate = formatReviewDate;
};

export {
  capitalize,
  formatDate,
  formatTime,
  numberToWordsOrdinal,
  daysRemaining,
  formatReviewDate
};